module.exports = __webpack_public_path__ + "img/basic_info.bed84cfe.svg";